import userService from '@/services/user.service';
import { useQuery } from 'react-query';
import { Outlet, useLocation } from 'react-router-dom';
import Scale from './Scale';
import './style.scss';

const PageLayoutLogin = () => {
    return (
        <div>
            <Outlet />
        </div>
    );
};

export default PageLayoutLogin;
